"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/ImportPatients/ImportPatientsDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);












var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _common = require('shared/selectors/org/common');
var _features = require('shared/selectors/org/features');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');

var _Form = require('web/components/Form');
var _RadioInput = require('web/components/Form/RadioInput');
var _Spinner = require('web/components/Spinner');
var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _format = require('web/screens/Broadcast/format');
var _helpers = require('web/screens/Broadcast/Wizard/helpers');
var _download = require('web/screens/Broadcast/Wizard/Recipients/download');


var _CsvImportDialog = require('web/screens/Broadcast/Wizard/Recipients/CsvImportDialog'); var _CsvImportDialog2 = _interopRequireDefault(_CsvImportDialog);
var _TagField = require('web/screens/Directory/Forms/TagField'); var _TagField2 = _interopRequireDefault(_TagField);

/* One page of the review. */
 const IMPORT_PAGE = 50; exports.IMPORT_PAGE = IMPORT_PAGE

const reasonFromError = (e) => {
  const reason = _optionalChain([(e ), 'optionalAccess', _ => _.Error])
  return typeof reason === 'string' ? reason : ''
}

/* b1-1x, b1-1y and the other files that can't be read: what to fix, in the
 * drop zone. */
const readError = (fileName, e) => {
  const reason = reasonFromError(e)
  const name = _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 44}},  fileName )
  if (/more than [\d,]+ rows/i.test(reason)) {
    return _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ": it has more than 50,000 rows. Split it into files of up to 50,000 rows and import each; patients in more than one file are matched, not added twice."                             )
  }
  if (/larger than 10 MB/i.test(reason)) {
    return _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ": it's larger than 10 MB. Split it into smaller files, or remove the columns you don't need, and import each."                    )
  }
  if (/more than [\d,]+ columns/i.test(reason)) {
    return _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ": it has more than 100 columns. Remove the columns you don't need and choose it again."                )
  }
  if (/no data rows|no header row/i.test(reason)) {
    return _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ": it has no rows to import. Choose a file with a header row and one row per patient."                  )
  }
  return reason ? _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ": " ,  reason ) : _react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  ,  name , ".")
}

const GUIDE = (
  _react2.default.createElement('ul', { className: "dir-import--guide", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
    , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "One row per patient, with a "      , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "name"), " and a "   , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "phone, email or MRN"   ), ".")
    , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "Someone already in the Directory (same MRN, phone or email) is "           , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "matched, not added twice"   ), ".")
    , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Up to 50,000 rows and 10 MB. On the last step you choose the tags, and what happens to patients already in the Directory."                       )
  )
)

const useDirectorySource = (orgKey) => {
  const preview = _react.useCallback.call(void 0, 
    (fileKey, mapping) => _actions2.default
      .previewDirectoryImport({ OrgKey: orgKey, FileKey: fileKey, Mapping: mapping, Limit: 1 })
      .then(p => ({ Columns: p.Columns, Headers: p.Headers, Mapping: p.Mapping, Rows: p.Rows })),
    [orgKey],
  )
  return _react.useMemo.call(void 0, 
    () => ({
      title: 'Import patients',
      stepCount: 3,
      allowVariables: false,
      declared: new Set(),
      preview,
      readError,
      guide: GUIDE,
      csvHint: '(in Excel: File › Save As › CSV)',
      className: 'dir-import',
    }),
    [preview],
  )
}

const EXISTING_TEXT = {
  leave: 'left as they are',
  fill: 'blanks filled in',
  update: 'updated from the file',
}

const MATCHED_ON = { mrn: 'same MRN', phone: 'same phone', email: 'same email' }

const PROBLEM_LABEL = {
  invalid_phone: 'Invalid phone',
  invalid_dob: 'Invalid date of birth',
  no_contact: 'No phone or email',
  archived: 'Archived',
}

const nameOf = (r) => [r.FirstName, r.LastName].filter(Boolean).join(' ') || r.Phone || r.Email || `Row ${r.Row}`

const statusOf = (r) => {
  if (r.Status === 'new') return { tone: 'new', label: 'New patient' }
  if (r.Status === 'matched') return { tone: 'quiet', label: 'In the Directory', why: r.MatchedOn ? MATCHED_ON[r.MatchedOn] : undefined }
  return { tone: 'error', label: (r.Problem && PROBLEM_LABEL[r.Problem]) || "Can't import" }
}

const VIEWS = [
  { value: 'all', label: 'All rows' },
  { value: 'new', label: 'New' },
  { value: 'matched', label: 'In the Directory' },
  { value: 'attention', label: 'Needs attention' },
]

const viewCount = (p, v) => {
  if (!p) return 0
  return { all: p.Counts.All, new: p.Counts.New, matched: p.Counts.Matched, attention: p.Counts.Attention }[v]
}






/* One page of a view of the review, read again whenever a row is removed. */
const useDirectoryReview = (orgKey, request, view, offset) => {
  const key = request ? JSON.stringify([request, view, offset]) : ''
  const [loaded, setLoaded] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, 
    () => {
      if (!request) return
      let isCurrent = true
      _actions2.default.previewDirectoryImport({ OrgKey: orgKey, ...request, View: view, Offset: offset, Limit: exports.IMPORT_PAGE })
        .then(preview => { if (isCurrent) setLoaded({ key, preview }) })
        .catch((e) => { if (isCurrent) setError({ key, text: _helpers.errorText.call(void 0, e, "Couldn't check the rows") }) })
      return () => { isCurrent = false }
    },
    [orgKey, request, view, offset, key, attempt],
  )
  const retry = _react.useCallback.call(void 0, () => {
    setError(null)
    setAttempt(n => n + 1)
  }, [])
  return {
    loaded,
    isCurrent: !!loaded && loaded.key === key,
    error: _optionalChain([error, 'optionalAccess', _2 => _2.key]) === key ? error.text : null,
    retry,
  }
}

/* Consent to text: the org's name while its consent setting is on, so
 * step 3 can offer to record the file's contacts as consented; else null.
 * Read each time the dialog opens. */
const useConsentOrgName = (orgKey, isOpen) => {
  const hasConsent = _hooks.useAppSelector.call(void 0, state => _features.selectOrgHasConsent.call(void 0, state, orgKey))
  const orgName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_common.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _3 => _3.Name]), () => ( '')))
  const [isRequired, setRequired] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, 
    () => {
      setRequired(false)
      if (!isOpen || !hasConsent) return
      let isCurrent = true
      _actions2.default.getOrgConsent({ OrgKey: orgKey })
        .then(view => { if (isCurrent) setRequired(view.Required) })
        .catch(e => log.error(e))
      return () => { isCurrent = false }
    },
    [orgKey, isOpen, hasConsent],
  )
  return isRequired ? orgName : null
}









/* D-98, B2: Import patients' steps 2 and 3. Review the rows against the
 * Directory (b2-2): New, In the Directory with what each matched on, and
 * Needs attention; a row can be removed. Then the options (b2-3): the tags
 * every created or matched patient gets, and what happens to the patients
 * already in the Directory. Import starts it in the background and closes
 * the dialog. */
const DirectoryImportSteps = ({
  file, isActive, stepLabel, onBack, onClose, setBusy, orgKey, tags, onStarted, consentOrgName,
}) => {
  const [step, setStep] = _react.useState('review')
  const [removed, setRemoved] = _react.useState([])
  const [view, setView] = _react.useState('all')
  const [offset, setOffset] = _react.useState.call(void 0, 0)
  const [tagValue, setTagValue] = _react.useState(_TagField.EMPTY_TAG_FIELD)
  const [existing, setExisting] = _react.useState('leave')
  const [isConsentAgreed, setConsentAgreed] = _react.useState.call(void 0, false)
  const [isStarting, setIsStarting] = _react.useState.call(void 0, false)
  const startingRef = _react.useRef.call(void 0, false)
  const [error, setError] = _react.useState(null)

  // The dialog gives these steps a new key for each mapped file, so a new
  // mapping starts the review again.

  const request = _react.useMemo.call(void 0, 
    () => ({ FileKey: file.fileKey, Mapping: file.mapping, Removed: removed }),
    [file, removed],
  )
  const { loaded, isCurrent, error: reviewError, retry } = useDirectoryReview(orgKey, isActive ? request : null, view, offset)
  if (!isActive) return null

  const preview = _nullishCoalesce(_optionalChain([loaded, 'optionalAccess', _4 => _4.preview]), () => ( null))
  // Removing the last row of the last page leaves the offset past the end:
  // go to the last page that still has rows (review F-10).
  if (isCurrent && preview && offset > 0 && offset >= preview.ViewTotal) {
    setOffset(Math.max(0, Math.ceil(preview.ViewTotal / exports.IMPORT_PAGE) - 1) * exports.IMPORT_PAGE)
  }
  const counts = _optionalChain([preview, 'optionalAccess', _5 => _5.Counts])
  const newCount = _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _6 => _6.New]), () => ( 0))
  const matchedCount = _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _7 => _7.Matched]), () => ( 0))
  // With nobody in the file already in the Directory there's nothing to
  // choose: the choice isn't shown, and the import leaves them (none) alone,
  // even if a choice was made before the matched rows were removed.
  const hasMatches = matchedCount > 0
  const existingSent = hasMatches ? existing : 'leave'
  const attention = _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _8 => _8.Attention]), () => ( 0))
  const hasTags = !_TagField.isTagFieldEmpty.call(void 0, tagValue)
  const tagged = newCount + matchedCount
  const fileName = _nullishCoalesce(_optionalChain([preview, 'optionalAccess', _9 => _9.FileName]), () => ( file.fileName))

  const remove = (row) => {
    setRemoved(r => r.includes(row) ? r : [...r, row])
  }
  const onDownload = () => {
    _actions2.default.downloadDirectoryImportErrors({ OrgKey: orgKey, FileKey: file.fileKey, Mapping: file.mapping, Removed: removed })
      .then(({ FileName, Csv }) => _download.downloadText.call(void 0, FileName || `${file.fileName.replace(/\.csv$/i, '')}-not-imported.csv`, Csv, 'text/csv'))
      .catch((e) => setError(_helpers.errorText.call(void 0, e, "Couldn't download the rows")))
  }

  const summary = (withChoice) => (
    _react2.default.createElement('div', { 'aria-label': "What the import does"   , className: _classBuilder2.default.call(void 0, 'broadcast-upload-dialog--sum', !isCurrent && 'broadcast-upload-dialog--sum--stale'), 'aria-busy': !isCurrent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}
      , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 250}},  _format.formatCount.call(void 0, newCount) ), " new · "   , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 250}},  _format.formatCount.call(void 0, matchedCount) ), " already in the Directory"
      ,  withChoice && hasMatches && _react2.default.createElement(_react2.default.Fragment, null, ", " ,  EXISTING_TEXT[existing] ) 
      ,  withChoice && hasTags && _react2.default.createElement(_react2.default.Fragment, null, " · all "   ,  _format.formatCount.call(void 0, tagged) , " tagged" ) 
      ,  attention > 0 && (
        _react2.default.createElement(_react2.default.Fragment, null
          , ' · '
          , _react2.default.createElement('span', { className: "broadcast-upload-dialog--sum-skipped", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}},  _format.formatCount.call(void 0, attention) , " can't be imported"   )
        )
      )
    )
  )

  const importLabel = [
    newCount > 0 ? `Import ${_format.formatCount.call(void 0, newCount)}` : 'Import',
    hasTags ? `tag ${_format.formatCount.call(void 0, tagged)}` : null,
  ].filter(Boolean).join(' · ')
  const hasWork = newCount > 0 || hasTags || existingSent !== 'leave'

  const onImport = () => {
    if (startingRef.current) return
    startingRef.current = true
    setIsStarting(true)
    setBusy(true)
    setError(null)
    _actions2.default.startDirectoryImport({
      OrgKey: orgKey,
      FileKey: file.fileKey,
      Mapping: file.mapping,
      Removed: removed,
      TagKeys: tagValue.TagKeys,
      NewTagNames: tagValue.NewNames,
      Existing: existingSent,
      ConsentAgreed: consentOrgName !== null && isConsentAgreed,
    })
      .then(status => {
        onStarted(status)
        onClose()
      })
      .catch((e) => setError(_helpers.errorText.call(void 0, e, "Couldn't start the import")))
      .finally(() => {
        startingRef.current = false
        setIsStarting(false)
        setBusy(false)
      })
  }

  if (step === 'options') {
    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('p', { className: "broadcast-csv-review--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}},  stepLabel(3, 'Options') )
        , _react2.default.createElement('div', { className: "dir-import--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}
          , _react2.default.createElement('section', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}
            , _react2.default.createElement('h3', { className: "dir-import--options-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}, "Tags")
            , _react2.default.createElement('p', { className: "dir-import--options-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}, "Every patient in the file gets them, new or already in the Directory."            )
            , _react2.default.createElement(_TagField2.default, {
              tags: tags,
              value: tagValue,
              onChange: setTagValue,
              createdWhen: "when the import starts"   ,
              isDisabled: isStarting,
              title: null,
              className: "dir-import--tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}
            )
          )
          ,  hasMatches && (
            _react2.default.createElement('section', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 315}}
              , _react2.default.createElement('h3', { className: "dir-import--options-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}}, "The "
                 ,  _format.formatCount.call(void 0, matchedCount) , " " ,  matchedCount === 1 ? 'patient' : 'patients' , " already in the Directory"
              )
              , _react2.default.createElement('p', { className: "dir-import--options-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 319}}, "Matched by MRN, then phone, then email."      )
              , _react2.default.createElement('div', { role: "radiogroup", 'aria-label': "Patients already in the Directory"    , className: "dir-import--choices", __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
                , _react2.default.createElement(_RadioInput.RadioOption, {
                  selected: existing === 'leave',
                  disabled: isStarting,
                  onClick: () => setExisting('leave'),
                  label: _react2.default.createElement(_react2.default.Fragment, null, "Leave them as they are"    , _react2.default.createElement('span', { className: "dir-import--choice-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}, "Only the tags are added. Today's patient import does this."         )), __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}}
                )
                , _react2.default.createElement(_RadioInput.RadioOption, {
                  selected: existing === 'fill',
                  disabled: isStarting,
                  onClick: () => setExisting('fill'),
                  label: _react2.default.createElement(_react2.default.Fragment, null, "Fill in what's missing"   , _react2.default.createElement('span', { className: "dir-import--choice-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 331}}, "A blank date of birth, email or MRN takes the file's value; nothing is overwritten."              )), __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}
                )
                , _react2.default.createElement(_RadioInput.RadioOption, {
                  selected: existing === 'update',
                  disabled: isStarting,
                  onClick: () => setExisting('update'),
                  label: _react2.default.createElement(_react2.default.Fragment, null, "Update them from the file"    , _react2.default.createElement('span', { className: "dir-import--choice-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}, "The file's non-blank values replace theirs. A phone never changes."         )), __self: this, __source: {fileName: _jsxFileName, lineNumber: 333}}
                )
              )
            )
          )
          ,  consentOrgName !== null && (
            _react2.default.createElement('section', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 343}}
              , _react2.default.createElement('h3', { className: "dir-import--options-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 344}}, "Consent to text"  )
              , _react2.default.createElement('p', { className: "dir-import--options-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 345}}, "Optional. Without it, BloomText asks each patient the first time your team texts them."             )
              , _react2.default.createElement('label', { className: "dir-import--consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 346}}
                , _react2.default.createElement('input', {
                  type: "checkbox",
                  checked: isConsentAgreed,
                  disabled: isStarting,
                  onChange: e => setConsentAgreed(e.target.checked), __self: this, __source: {fileName: _jsxFileName, lineNumber: 347}}
                )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 353}}, "These patients agreed to get texts from "
                         ,  consentOrgName || 'your organization' 
                  , _react2.default.createElement('span', { className: "dir-import--choice-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}, "Only check this if each person in the file agreed. BloomText records it as consent for each phone, with your name, the date and the file name."

                  )
                )
              )
            )
          )
        )
        ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 363}},  error ) 
        , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-upload-dialog--foot--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 364}}
          ,  summary(true) 
          , _react2.default.createElement('span', { className: "broadcast-upload-dialog--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 366}} )
          , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isStarting, onClick: () => setStep('review'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}}, "Back")
          , _react2.default.createElement(_Form.Button, { isDisabled: !isCurrent || !hasWork, isLoading: isStarting, onClick: onImport, __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}},  importLabel )
        )
      )
    )
  }

  const removedRows = new Set(removed)
  const rows = (_nullishCoalesce(_optionalChain([preview, 'optionalAccess', _10 => _10.Page]), () => ( []))).filter(r => !removedRows.has(r.Row))
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('p', { className: "broadcast-csv-review--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 378}},  stepLabel(2, 'Review rows') )
      , _react2.default.createElement('div', { className: "broadcast-csv-review--bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 379}}
        , _react2.default.createElement('div', { className: "broadcast-csv-review--switch", role: "group", 'aria-label': "Show rows" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 380}}
          ,  VIEWS.map(v => (
            _react2.default.createElement('button', {
              key: v.value,
              type: "button",
              'aria-pressed': view === v.value,
              className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--switch-option', view === v.value && 'broadcast-csv-review--switch-option--on'),
              onClick: () => {
                setView(v.value)
                setOffset(0)
              }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 382}}

              ,  v.label , " · "  ,  _format.formatCount.call(void 0, viewCount(preview, v.value)) 
            )
          ))
        )
        , _react2.default.createElement('select', {
          'aria-label': "Show rows" ,
          className: "blm-simple-select dir-import--view-select" ,
          value: view,
          onChange: e => {
            setView(e.target.value )
            setOffset(0)
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}

          ,  VIEWS.map(v => _react2.default.createElement('option', { key: v.value, value: v.value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 405}},  v.label , " · "  ,  _format.formatCount.call(void 0, viewCount(preview, v.value)) )) 
        )
        , _react2.default.createElement('span', { className: "broadcast-csv-review--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 407}} )
        ,  attention > 0 && (
          _react2.default.createElement('button', { type: "button", className: "broadcast-mapping--link", onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 409}}, "Download rows that can't be imported"

          )
        )
        , _react2.default.createElement('span', { className: "broadcast-csv-review--file", title: fileName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 413}},  fileName )
      )
      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--scroll', loaded && !isCurrent && 'broadcast-csv-review--stale'), 'aria-busy': !isCurrent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 415}}
        , _react2.default.createElement('table', { className: "broadcast-csv-review", 'aria-label': "Rows to import"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 416}}
          , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 417}}
            , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 418}}
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 419}}, "Patient")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 420}}, "Contact")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 421}}, "MRN")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 422}}, "Status")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 423}}, _react2.default.createElement('span', { className: "broadcast-visually-hidden", __self: this, __source: {fileName: _jsxFileName, lineNumber: 423}}, "Actions"))
            )
          )
          , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 426}}
            ,  !loaded && !reviewError && (
              _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 428}}, _react2.default.createElement('td', { colSpan: 5, className: "broadcast-csv-review--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 428}}, _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--table--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 428}} ), " Checking the rows against the Directory…"      ))
            )
            ,  !loaded && reviewError && (
              _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 431}}
                , _react2.default.createElement('td', { colSpan: 5, className: "broadcast-csv-review--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 432}}
                  , _react2.default.createElement('span', { role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 433}},  reviewError , "."), ' '
                  , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 434}}, "Try again" )
                )
              )
            )
            ,  loaded && rows.length === 0 && (
              _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 439}}, _react2.default.createElement('td', { colSpan: 5, className: "broadcast-csv-review--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 439}}, "No rows here."  ))
            )
            ,  rows.map(r => {
              const status = statusOf(r)
              const name = nameOf(r)
              return (
                _react2.default.createElement('tr', { key: r.Row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 445}}
                  , _react2.default.createElement('th', { scope: "row", className: "broadcast-csv-review--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 446}},  name )
                  , _react2.default.createElement('td', { className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--contact', status.tone === 'error' && r.Problem !== 'archived' && 'broadcast-csv-review--bad'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 447}},  r.Phone || r.Email )
                  , _react2.default.createElement('td', { className: "dir-import--mrn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 448}},  r.MRN )
                  , _react2.default.createElement('td', { className: "broadcast-csv-review--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 449}}
                    , _react2.default.createElement('span', { className: `campaign--table--status-pill broadcast-csv-review--pill broadcast-csv-review--pill-${status.tone}`, title: r.Error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 450}}
                      , _react2.default.createElement('span', { className: "campaign--table--status-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 451}},  status.label )
                    )
                    ,  status.why && _react2.default.createElement('span', { className: "dir-import--why", __self: this, __source: {fileName: _jsxFileName, lineNumber: 453}},  status.why ) 
                  )
                  , _react2.default.createElement('td', { className: "broadcast-csv-review--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 455}}
                    , _react2.default.createElement('button', { type: "button", className: "broadcast-csv-review--icon", 'aria-label': `Remove ${name}`, onClick: () => remove(r.Row), __self: this, __source: {fileName: _jsxFileName, lineNumber: 456}}, "🗑"

                    )
                  )
                )
              )
            })
          )
        )
      )
      , _react2.default.createElement(_RecipientTable.RecipientPager, {
        page: Math.floor(offset / exports.IMPORT_PAGE),
        pageCount: Math.ceil((_nullishCoalesce(_optionalChain([preview, 'optionalAccess', _11 => _11.ViewTotal]), () => ( 0))) / exports.IMPORT_PAGE),
        onPage: page => setOffset(page * exports.IMPORT_PAGE),
        className: "broadcast-csv-review--pager", __self: this, __source: {fileName: _jsxFileName, lineNumber: 466}}
      )
      ,  loaded && reviewError && (
        _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 473}}
          ,  reviewError , ".", ' '
          , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 475}}, "Try again" )
        )
      )
      ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 478}},  error ) 
      , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-upload-dialog--foot--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 479}}
        ,  counts && summary(false) 
        , _react2.default.createElement('span', { className: "broadcast-upload-dialog--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 481}} )
        , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 482}}, "Back")
        , _react2.default.createElement(_Form.Button, { isDisabled: !isCurrent || !!reviewError || newCount + matchedCount === 0, onClick: () => setStep('options'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 483}}, "Next: options" )
      )
    )
  )
}









/* D-97, D-98: Import patients, from the Patients tab's import button (admins
 * only, D-101). The broadcast's choose and map steps (patient fields only),
 * then the review and the options. */
const ImportPatientsDialog = ({ isOpen, orgKey, tags, onClose, onStarted }) => {
  const source = useDirectorySource(orgKey)
  const consentOrgName = useConsentOrgName(orgKey, isOpen)
  return (
    _react2.default.createElement(_CsvImportDialog2.default, {
      isOpen: isOpen,
      source: source,
      onClose: onClose,
      renderSteps: steps => _react2.default.createElement(DirectoryImportSteps, { ...steps, orgKey: orgKey, tags: tags, onStarted: onStarted, consentOrgName: consentOrgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 508}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 504}}
    )
  )
}

exports. default = ImportPatientsDialog
